import { DARK_BLUE_COLOR, ACTION_CURRENT_COLOR, DEFAULT_FONTFAMILY } from 'theme/theme';

export default {
  PlanDetails: {
    width: '100%',
  },
  topHeader: {
    height: 24,
    color: DARK_BLUE_COLOR,
    marginTop: 30,
    letterSpacing: '1px',
    font: `500 14px/18px ${DEFAULT_FONTFAMILY}`,
    textTransform: 'uppercase',
    '&.congratulation': {
      font: `600 16px/20px ${DEFAULT_FONTFAMILY}`,
      textTransform: 'none',
    },
  },
  header: {
    marginTop: 20,
    fontSize: 20,
    fontWeight: 700,
  },
  description: {
    marginTop: 10,
    fontSize: '14px',
    fontWeight: 400,
    font: `400 14px/18px ${DEFAULT_FONTFAMILY}`,
    whiteSpace: 'nowrap',
    '@media screen and (max-width: 1024px)': {
      whiteSpace: 'normal',
    },
  },
  strong: {
    fontWeight: 500,
  },
  successFooter: {
    marginTop: 20,
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '17px',
  },
  help: {
    color: `${ACTION_CURRENT_COLOR}!important`,
    margin: [0,5],
    textDecoration: 'underline',
  },
  link: {
    extend: 'help',
    margin: 0,
  },
  techFooter: {
    marginTop: 50,
    font: `400 13px/18px ${DEFAULT_FONTFAMILY}`,
    opacity: 0.7,
    textAlign: 'center',
  },
};
